export enum Holidays {
  None = 0,
  NewYearsDay = 1,
  MartinLutherKingJrDay = 2,
  PresidentsDay = 4,
  MemorialDay = 8,
  IndependenceDay = 16,
  LaborDay = 32,
  ColumbusDay = 64,
  VeteransDay = 128,
  ThanksgivingDay = 256,
  ChristmasDay = 512,
  Juneteenth = 1024,
  ChristmasEve = 2048
}

export const HolidaysMapping: Record<Holidays, string> = {
  [Holidays.None]: 'None',
  [Holidays.NewYearsDay]: "New Year's Day",
  [Holidays.MartinLutherKingJrDay]: 'Martin Luther King Jr. Day',
  [Holidays.PresidentsDay]: "President's Day",
  [Holidays.MemorialDay]: 'Memorial Day',
  [Holidays.IndependenceDay]: 'Independence Day',
  [Holidays.LaborDay]: 'Labor Day',
  [Holidays.ColumbusDay]: 'Columbus Day',
  [Holidays.VeteransDay]: 'Veterans Day',
  [Holidays.ThanksgivingDay]: 'Thanksgiving Day',
  [Holidays.ChristmasDay]: 'Christmas Day',
  [Holidays.Juneteenth]: 'Juneteenth',
  [Holidays.ChristmasEve]: 'Christmas Eve'
};

export function HolidaysToString(holidays: Holidays): string {
  if (holidays === Holidays.None) return 'None';
  const response: string[] = [];
  if (holidays & Holidays.NewYearsDay) response.push("New Year's Day");
  if (holidays & Holidays.MartinLutherKingJrDay) response.push('Martin Luther King Jr. Day');
  if (holidays & Holidays.PresidentsDay) response.push("President's Day");
  if (holidays & Holidays.MemorialDay) response.push('Memorial Day');
  if (holidays & Holidays.Juneteenth) response.push('Juneteenth');
  if (holidays & Holidays.IndependenceDay) response.push('Independence Day');
  if (holidays & Holidays.LaborDay) response.push('Labor Day');
  if (holidays & Holidays.ColumbusDay) response.push('Columbus Day');
  if (holidays & Holidays.VeteransDay) response.push('Veterans Day');
  if (holidays & Holidays.ThanksgivingDay) response.push('Thanksgiving Day');
  if (holidays & Holidays.ChristmasEve) response.push('Christmas Eve');
  if (holidays & Holidays.ChristmasDay) response.push('Christmas Day');
  return response.join(', ');
}